<div class="upload-file-section">
  <div class="stepper-panel">
    <nz-steps class="upload-stepper" [nzCurrent]="current">
      <nz-step nzTitle="Upload File" />
      <nz-step nzTitle="Field Mapping" />
    </nz-steps>
  </div>

  <div class="stepper-content">
    <nz-spin [nzSpinning]="spinning">
      <app-file-upload-step
        *ngIf="index === 'uploadFile'"
        [files]="files"
        [fields]="targetFields"
        [getBeforeUploadHandler]="getBeforeUploadHandler.bind(this)"
        (addFile)="addFile()"
        (removeFile)="removeFile($event)"
        (clearFiles)="clearFiles()"
        (isFormValid)="checkFormValidity($event)"
      ></app-file-upload-step>
    </nz-spin>

    <app-field-mapping-step
      *ngIf="index === 'fieldMapping'"
      [form]="form"
      [fields]="targetFields"
      [fileOptions]="fileOptions"
      [columnOptionsByFile]="columnOptionsByFile"
      [validationLogs]="validationLogs"
      [filesValidated]="filesValidated"
      [isLoading]="isLoading"
      [isProcessing]="isProcessing"
      [isPublishing]="isPublishing"
      (saveAndValidateMapping)="validateAndSaveMapping()"
      (process)="saveMetadataAndProcess()"
      (export)="export()"
      (back)="pre()"
    ></app-field-mapping-step>

    <nz-progress *ngIf="progressRatio > 0 && index === 'uploadFile'" [nzPercent]="progressRatio"></nz-progress>
  </div>
  <div class="action-btn-panel">
    <button
      *ngIf="current < 1"
      nz-button
      nzType="default"
      (click)="clearFiles()"
      class="clear-btn"
      [disabled]="!hasFilesSelected"
    >
      <span nz-icon nzType="reload"></span>
      Clear All Files
    </button>
    <button
      class="next-btn"
      nzSize="large"
      *ngIf="current < 1"
      nz-button
      nzType="default"
      (click)="next()"
      [disabled]="!hasFilesSelected || !isFileFormValid"
    >
      <span>Save and Next </span>
    </button>
  </div>
</div>
